/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface PostCreditCardPaymentWebhookRequest {
    stripeSignature: string;
    body: string;
}

/**
 * 
 */
export class ConnectStripeApi extends runtime.BaseAPI {

    /**
     * Stripeからのクレジットカード3Dセキュア決済の通知を受け取るWebhookです。 
     * クレカ3DS決済通知受付Webhook
     */
    async postCreditCardPaymentWebhookRaw(requestParameters: PostCreditCardPaymentWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.stripeSignature === null || requestParameters.stripeSignature === undefined) {
            throw new runtime.RequiredError('stripeSignature','Required parameter requestParameters.stripeSignature was null or undefined when calling postCreditCardPaymentWebhook.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling postCreditCardPaymentWebhook.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.stripeSignature !== undefined && requestParameters.stripeSignature !== null) {
            headerParameters['Stripe-Signature'] = String(requestParameters.stripeSignature);
        }

        const response = await this.request({
            path: `/v1/connect/stripe/creditcardPayment/webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stripeからのクレジットカード3Dセキュア決済の通知を受け取るWebhookです。 
     * クレカ3DS決済通知受付Webhook
     */
    async postCreditCardPaymentWebhook(requestParameters: PostCreditCardPaymentWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postCreditCardPaymentWebhookRaw(requestParameters, initOverrides);
    }

}
